import { Component, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, UrlSerializer } from '@angular/router';
import { AscService } from '@draeger-academy/common/lib/services/acs-input/acs.service';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { CoursesService } from '@draeger-academy/common/lib/services/courses/courses.services';
import { PortalConfigurationService } from '@draeger-academy/common/lib/services/portal-configuration/portal-configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { Course } from '../../../../../models/course';
import { FilterParameter} from '../../../../../models/filter-parameter';
import { FilteringComponent } from '../filtering/filtering.component';
import { SelectComponent } from '../select/select.component';
import { ShowMoreComponent } from '../show-more/show-more.component';
import { AuthenticationService, SubscriptionCollector, UrlService } from '@draeger-academy/common';
import {Location} from '@angular/common'; 
import * as _ from 'lodash';

@Component({
    selector: 'da-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss'],
    standalone: false
})
export class CourseListComponent implements OnInit, OnDestroy {
    @ViewChild('showMoreSection') showMoreSection: ShowMoreComponent;
    @Input() portal: string = null;
    public categoryName = '';
    public active = false;
    public coursesPerPage = 10;
    public isPartnerPage = false;
    public hasFocus = false;
    public sortingSelectedValue = null;
    public numberOfCourses = 0;
    public hasFocusTitle = false;
    public isPresence = true;
    public isOnline = true;
    public isVirtual = true;
    public show = false;
    public coursesByTitle: Course[];
    public month = 0;
    public year: Number;
    public city: string;
    public sortValue = '';
    public hasFocusYear = false;
    public hasFocusMonth = false;
    public hasFocusCity = false;
    public expand = false;
    public linkToTrainingAdvisor: string;
    public showTextToTrainingAdvisor = false;
    public courses: Course[];
    public site: string;
    public label: string;
    public isUserPage = false;
    public portalLanguage: string;
    public selectedValueForCity: string;
    public selectedValueYear: string;
    public selectedValueMonth: string;
    public selectedSortingKey: string;
    public countryCode: string;
    public extendedFilterSelected = false;
    public filterResetDone = false;
    public lang: string;
    public coursesWithoutDivision = false;
    public parameter: FilterParameter = {};
    public currentLanguage: string;
    public sortedCourses = [];
    public hasDivision = false;
    private innerScreenWidth: number;

    private _$categories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$sortOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseFilterMonths: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseFilterYears: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$courseTypeFilterOptions: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$showServerError: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showCart: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$loading: BehaviorSubject<boolean> = new BehaviorSubject(true);
    private _$courses: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$selectedValue: BehaviorSubject<string> = new BehaviorSubject('0');
    private _$selectedValueSubCat: BehaviorSubject<string> = new BehaviorSubject('0');
    private _$selectedValueSubSubCat: BehaviorSubject<string> = new BehaviorSubject('0');
    private _$title: BehaviorSubject<string> = new BehaviorSubject('');
    private _$coursesFiltered: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$coursesFilteredMore: BehaviorSubject<Course[]> = new BehaviorSubject<Course[]>(null);
    private _$courseFilterCities: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(null);
    private _$serverError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$show: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$showSecondLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private _$hideFirstLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$showThirdLevelFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private _$showMoreInformation: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _$numberOfCourses: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private _$availableCities: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private _$availableYears: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private _$availableMonths: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    private _subscriptionSiteSettings: Subscription;
    private _subscriptionQueryParams: Subscription;
    private _subscriptionCourses: Subscription;
    private _$translations: BehaviorSubject<any> = new BehaviorSubject({});
    public parameterFromURL: FilterParameter = {};
    private _$hasLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject(false); 
    @ViewChild(FilteringComponent) filters: FilteringComponent;
    @ViewChild(SelectComponent) select: SelectComponent;
    @SubscriptionCollector() private _subscription;
    constructor(
        private activatedRoute: ActivatedRoute,
        private _router: Router,
        private _coursesService: CoursesService,
        private _portalConfigurationService: PortalConfigurationService,
        private _configurationService: ConfigurationService,
        private _translateService: TranslateService,
        private asc: AscService,
        private _authenticationService: AuthenticationService,
        private _location: Location,
        private _urlService: UrlService
    ) {
        _translateService.get('routes.training-advisor').subscribe((res: string) => {
            if (res && res !== 'routes.training-advisor') {
                this.showTextToTrainingAdvisor = true;
            }
        });
    }

    public get showServerError$(): Observable<boolean> {
        return this._$showServerError.asObservable();
    }

    public get hasLoggedIn$(): Observable<boolean> {
        return this._$hasLoggedIn.asObservable();
    }

    public get loading$(): Observable<boolean> {
        return this._$loading.asObservable();
    }

    public get showSecondLevelFiltering$(): Observable<boolean> {
        return this._$showSecondLevelFiltering.asObservable();
    }

    public get hideFirstLevelFiltering$(): Observable<boolean> {
        return this._$hideFirstLevelFiltering.asObservable();
    }

    public get showThirdLevelFiltering$(): Observable<boolean> {
        return this._$showThirdLevelFiltering.asObservable();
    }

    public get serverError$(): Observable<{}> {
        return this._$serverError.asObservable();
    }

    public get showFilter$(): Observable<boolean> {
        return of(this._$coursesFiltered.getValue()?.length > 0 && this._$categories.getValue() !== null);
    }

    public get coursesFiltered$(): Observable<Course[]> {
        return this._$coursesFiltered.asObservable();
    }

    public get coursesFilteredMore$(): Observable<Course[]> {
        return this._$coursesFilteredMore.asObservable();
    }

    public get showMoreInformation$(): Observable<boolean> {
        return this._$showMoreInformation.asObservable();
    }

    public get showFiltering$(): Observable<boolean> {
        return this._$showFiltering.asObservable();
    }

    public get show$(): Observable<boolean> {
        return this._$show.asObservable();
    }

    public get categories$(): Observable<any> {
        return this._$categories.asObservable();
    }

    public get sortOptions$(): Observable<any> {
        return this._$sortOptions.asObservable();
    }

    public get courseTypeFilterOptions$(): Observable<any> {
        return this._$courseTypeFilterOptions.asObservable();
    }

    public get courseFilterCities$(): Observable<any> {
        return this._$courseFilterCities.asObservable();
    }

    public get courseFilterMonths$(): Observable<any> {
        return this._$courseFilterMonths.asObservable();
    }

    public get courseFilterYears$(): Observable<any> {
        return this._$courseFilterYears.asObservable();
    }
    public get numberOfCourses$(): Observable<number> {
        return this._$numberOfCourses.asObservable();
    }

    public closeError() {
        this._$showServerError.next(false);
    }

    ngOnDestroy() {
        if (this._subscriptionSiteSettings) {
            this._subscriptionSiteSettings.unsubscribe();
        }
        if (this._subscriptionQueryParams) {
            this._subscriptionQueryParams.unsubscribe();
        }
        if (this._subscriptionCourses) {
            this._subscriptionCourses.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this._authenticationService.isLoggedIn()) {
                this._$hasLoggedIn.next(true);
                this.parameterFromURL = null;
                this.parameter.division = null;
                this.resetFilters();
            
        } 
    }

    ngOnInit(): void {      
        if (this._$show.getValue() === true) {
            this.toggleFilters(true);
        } else {
            this.toggleFilters(false);
        }
        this.innerScreenWidth = window.innerWidth;

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        if (isPortal) {
            sessionStorage.removeItem(`selectedSortingValue${currentPortal}`);

        } else {
            const _site = this._configurationService.getCurrentSite();
            sessionStorage.removeItem(`selectedSortingValue${_site}`);
        } 
        this.setSortingLabelToAlphabetically();
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
            this.site = site;
        }
        const _site = isPortal ? currentPortal : site;

        this.currentLanguage =
            JSON.parse(sessionStorage.getItem('portalLang')) && JSON.parse(sessionStorage.getItem('portalLang')).lang
                ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                : '';
        this.portalLanguage = this.currentLanguage;
        this.initGetCoureses();

        this._$showCart.next(this._configurationService.hasFeature('ShoppingCart'));

        this.showFiltering();

        this._$showSecondLevelFiltering.next(
            this._configurationService.hasFeature('SecondLevelFiltering') || this._configurationService.isPartnerPage()
        );
        this._$showThirdLevelFiltering.next(
            this._configurationService.hasFeature('ThirdLevelFiltering') || this._configurationService.isPartnerPage()
        );
        this.setMonthsOptions();


        this._subscription.push(
            this._configurationService.isSiteLoaded$.subscribe((siteLoaded) => {
                if (siteLoaded) {
                    this.setMonthsOptions();
                }
            })
        );

    
            if (localStorage.getItem(`showMoreCourses${_site}${this.currentLanguage}`) === 'true') {
            this.showMore(true);
            this.expand = true;
        }

        this._translateService.get('routes.training-advisor'.toLowerCase()).subscribe((data) => {
            if (data) {
                this._$translations.next(data);
                this.linkToTrainingAdvisor = `/${_site}/${data}`;
            }
        });
        this._coursesService.languageSelected.subscribe((language) => {
            this.getParameterFromURL();
            this.currentLanguage = language.toString();
            this.initGetCoureses();
        });

        this._authenticationService.loggedIn().subscribe((data) => {
            if (data === null && this._$hasLoggedIn.getValue()) {
                this.parameterFromURL = null;
                this.parameter.division = null;
                this._$hasLoggedIn.next(false);
                this.resetFilters();
                this.initGetCoureses();
                this.setSortingLabelToAlphabetically();
            }
        });
    }

    private setSortingLabelToAlphabetically(){
        if (this.isPartnerPage) {
            sessionStorage.setItem(`selectedSortingValue${this.portal}`, 'name');
            this.sortValue = 'name';
            this.selectedSortingKey = this.sortValue;
        } else {
            const _site = this._configurationService.getCurrentSite();
            sessionStorage.setItem(`selectedSortingValue${_site}`, 'name');
            this.sortValue = 'name';
            this.selectedSortingKey = this.sortValue;
        }
    }

    initGetCoureses() {
        this.isPartnerPage = this._configurationService.isPartnerPage();

        let prom1: Promise<any>;
        if (this.portal) {
            this._portalConfigurationService.loadPortalPreferences(this.portal).then((preferences) => {
                this.lang = this._portalConfigurationService.getPortalLanguage(preferences);
                prom1 = this._getPortalCourses(this.portal);
                // this.getSortingOptions(this.lang, this.courses);
                this.furtherStepsToInitCourses(prom1);
            });

        } else {
            prom1 = this.getCourses();
            // this.getSortingOptions(this.currentLanguage, this.courses);
            this.furtherStepsToInitCourses(prom1);
        }
    }

    private furtherStepsToInitCourses(prom1){
        Promise.all([prom1]).then((proms) => {
            this._$loading.next(false);
            this._translateService.stream('common'.toLowerCase()).subscribe((data) => {
                this._$translations.next(data);
                this.label = this._$translations.getValue().filteringDropdownAll
                    ? this._$translations.getValue().filteringDropdownAll
                    : 'All';
                const isPortal = this._configurationService.isPartnerPage();
                if (isPortal) {
                    this.updatePortalCategories(this._$categories.getValue());
                } else {
                    this.updateCategories(this._$categories.getValue());
                }
                let foundCategoryAllInArray = false
                const newCategoriesWithoutDoubleAllCat = [];
                this._$categories.getValue().forEach((category) =>{
                    if (category.id !== 0 || (category.id === 0 && !foundCategoryAllInArray)) {
                        foundCategoryAllInArray = true;
                        newCategoriesWithoutDoubleAllCat.push(category);
                        this._$categories.next(newCategoriesWithoutDoubleAllCat);
                    }
                });
                this.getParameterFromURL();
                this.getSortingOptions(this.currentLanguage, this.courses);

                this._parseCourses(proms[0]);
                this.getParameterFromURL();
            });
        });
    }

    public showFiltering() {
        const isPortal = this._configurationService.isPartnerPage();

        if (!isPortal) {
            this._$showFiltering.next(this._configurationService.hasFeature('SearchBy'));
        } else {
            this._configurationService.getConfigPartnerByPortal().then((values) => {
                if (values) {
                    const tempFeatures = values.filter((setting) => setting.key.toLowerCase() === 'features');
                    let hasCheckPrerequest;
                    if (tempFeatures && tempFeatures[0] && tempFeatures[0].value && tempFeatures[0].value.length > 0) {
                        hasCheckPrerequest = tempFeatures[0].value.filter((setting) => setting.name === 'SearchBy');
                    }
                    if (hasCheckPrerequest && hasCheckPrerequest[0] && hasCheckPrerequest[0].enabled) {
                        this._$showFiltering.next(true);
                    }
                }
            });
        }
    }

    public setMonthsOptions() {
        const _monthsOptions = this._configurationService.MonthsOptions;
        if (_monthsOptions && _monthsOptions[0]) {
            const _monthOptionsValues = _monthsOptions[0].value;
            this._$courseFilterMonths.next(_monthOptionsValues.sort((a, b) => Number(a.key) - Number(b.key)));
            this._$availableMonths.next(_monthOptionsValues);
        }
    }

    public compareNumbers(a, b) {
        return b - a;
    }

    public changeView(active, $event: Event) {
        $event.preventDefault();
        if (!active) {
            this.active = !this.active;
        }

        this.innerScreenWidth = window.innerWidth;

        if (this.portal) {
            this._getPortalCourses(this.portal);
        } else {
            this.getCourses();
        }
    }

    public onSelect(categoryId) {
        if (categoryId === null || !categoryId) {
            categoryId = '0';
        }
        if (this._$categories.getValue()) {
            this._$categories.getValue().filter((data) => {
                if (
                    (data && data.id && data.id.toString() === categoryId) ||
                    (data && data.id === 0 && data.id.toString() === categoryId)
                ) {
                    this.categoryName = data.name;
                    this._$selectedValue.next(categoryId);
                    if (categoryId === '0') {
                        this._$selectedValue.next(null);
                        this._$selectedValueSubCat.next(null);
                        this._$selectedValueSubSubCat.next(null);
                    }
                }
            });
        }
        this.filterCourses();
    }
    public onSelectDivision(value) {
        this._$selectedValueSubCat.next(null);
        this._$selectedValueSubSubCat.next(null);
    }
    

    public onSelectSubCat(value) {
        this._$selectedValueSubCat.next(value);
        this._$selectedValueSubSubCat.next(null);
        this.filterCourses();
    }

    public onSelectSubSubCat(categoryId) {
        this._$selectedValueSubSubCat.next(categoryId);
        this.filterCourses();
    }

    public showMore($event: boolean) {
        this._$showMoreInformation.next($event);

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
        }
        const _site = isPortal ? currentPortal : site;
        localStorage.setItem(`showMoreCourses${_site}`, $event.toString());

        // f (this.showMoreSection) this.showMoreSection._$showMore.next($event);

        this.innerScreenWidth = window.innerWidth;

        if (this.expand) {
            localStorage.setItem(`showMoreCourses${_site}`, 'false');
        }
        this.expand = !this.expand;
    }

    public filterCourses() {
        if (this._$categories.getValue()?.length === 1) {
            this._$selectedValue.next(this._$categories.getValue()[0].id);
        }
        let filteredMore = [];
        let coursesFiltered = [];        
        const _labelNoValue = this._$translations.getValue().filteringDropdownNoSelection
            ? this._$translations.getValue().filteringDropdownNoSelection
            : 'No selected value';
        let _site;
        if (this._configurationService.getSiteFromUrl()) {
            _site = this._configurationService.getSiteFromUrl().site;
        }
        let seletedValue = this._$selectedValue.getValue();
        const selectedValueSubCat = this._$selectedValueSubCat.getValue();
        const selectedValueSubSubCat = this._$selectedValueSubSubCat.getValue();
        if (seletedValue === undefined) {
            seletedValue = null;
        }

        if (seletedValue === '0' || seletedValue === 'null' || seletedValue === null || seletedValue === this.label) {    
                this.parameter.division = null;

            if (this._configurationService.$coursesPerPage) {
                this._subscriptionCourses = this._configurationService.$coursesPerPage.subscribe((data) => {
                    if (data) {
                        this.coursesPerPage = Number(data);
                    }
                });
            }

            if (this._$courses.getValue() && this._$courses.getValue().length > 0) {
                let courses = this._$courses.getValue();
                this.sortCourses(this._$courses.getValue());
                courses = this.sortedCourses;

                if (this._configurationService.CourseTypeFilterOptions && this._configurationService.CourseTypeFilterOptions.length > 0) {
                    courses = this.filterByType(courses);
                }                


                courses = this.filterByTitle(courses);

                if (this._configurationService.MonthsOptions && this._configurationService.MonthsOptions.length > 0) {
                    courses = this.filterByMonth(courses);
                }

                if (this._configurationService.YearsOptions && this._configurationService.YearsOptions.length > 0) {
                    courses = this.filterByYear(courses);
                }

                courses = this.filterByCity(courses);
                this._$numberOfCourses.next(courses.length);
                filteredMore = courses.slice(this.coursesPerPage, this._$courses.getValue().length);
                this.coursesByTitle = courses;
                coursesFiltered = courses.slice(0, this.coursesPerPage);
                this._$coursesFilteredMore.next(filteredMore);
                this._$coursesFiltered.next(coursesFiltered);
                if (!this.extendedFilterSelected) {
                    this.checkIfCoursesHaveEvents(coursesFiltered);
                    this.checkIfCoursesHaveEvents(filteredMore);
                }
            }
        } else {
            if (
                this._$courses.getValue() &&
                seletedValue !== '0' &&
                (!selectedValueSubCat ||
                    selectedValueSubCat === this.label ||
                    selectedValueSubCat === 'All' ||
                    selectedValueSubCat === 'null' ||
                    selectedValueSubCat === null ||
                    selectedValueSubCat === _labelNoValue ||
                    selectedValueSubCat === 'No selected value') &&
                (!selectedValueSubSubCat ||
                    selectedValueSubSubCat === this.label ||
                    selectedValueSubSubCat === 'All' ||
                    selectedValueSubSubCat === 'null' ||
                    selectedValueSubSubCat === null ||
                    selectedValueSubSubCat === _labelNoValue ||
                    selectedValueSubSubCat === 'No selected value')
            ) {
                this._$courses.getValue().filter((course) => {
                    course.divisions.forEach((item) => {
                        if (item.key === seletedValue || item.name === seletedValue) {
                            filteredMore = [];
                            coursesFiltered.push(course);
                        }
                    });
                    if (course.divisions.length > 0) {
                        this.hasDivision = true;
                    }
                    if (!this.hasDivision) {
                        coursesFiltered.push(course);
                    }
                });
            }

            if (
                this._$courses.getValue() &&
                seletedValue &&
                selectedValueSubCat &&
                (!selectedValueSubSubCat ||
                    selectedValueSubSubCat === this.label ||
                    selectedValueSubSubCat === 'All' ||
                    selectedValueSubSubCat === _labelNoValue ||
                    selectedValueSubSubCat === 'No selected value')
            ) {
                this._$courses.getValue().filter((course) => {
                    const upperCaseNames = course.trainingSegments.map((value) => {
                        return value.toUpperCase();
                    });
                    course.divisions.forEach((item) => {
                        if (
                            (item.key === seletedValue || item.name === seletedValue) &&
                            upperCaseNames.indexOf(selectedValueSubCat.toUpperCase()) > -1
                        ) {
                            filteredMore = [];
                            coursesFiltered.push(course);
                        }
                    });
                    if (course.divisions.length > 0) {
                        this.hasDivision = true;
                    }
                    if (!this.hasDivision) {
                        coursesFiltered.push(course);
                    }
                });
            }

            if (
                this._$courses.getValue() &&
                seletedValue &&
                selectedValueSubCat &&
                selectedValueSubSubCat &&
                selectedValueSubCat !== this.label &&
                selectedValueSubCat !== 'All' &&
                selectedValueSubSubCat !== this.label &&
                selectedValueSubSubCat !== 'All'
            ) {
                this._$courses.getValue().filter((course) => {
                    const upperCaseTrainigSegments = course.trainingSegments.map((value) => {
                        return value.toUpperCase();
                    });

                    const upperCaseProductAreas = course.productAreas.map((value) => {
                        return value.toUpperCase();
                    });
                    course.divisions.forEach((item) => {
                        if (
                            (item.key === seletedValue || item.name === seletedValue) &&
                            upperCaseTrainigSegments.indexOf(selectedValueSubCat.toUpperCase()) > -1 &&
                            upperCaseProductAreas.indexOf(selectedValueSubSubCat.toUpperCase()) > -1
                        ) {
                            coursesFiltered.push(course);
                        }
                        if (course.divisions.length > 0) {
                            this.hasDivision = true;
                        }
                        if (!this.hasDivision) {
                            coursesFiltered.push(course);
                        }
                    });
                });
            }

            let courses = coursesFiltered;

            this.sortCourses(courses);
            courses =  this.sortedCourses;

            if (this._configurationService.CourseTypeFilterOptions && this._configurationService.CourseTypeFilterOptions.length > 0) {
                courses = this.filterByType(courses);
            }

            courses = this.filterByTitle(courses);

            if (this._configurationService.MonthsOptions && this._configurationService.MonthsOptions.length > 0) {
                courses = this.filterByMonth(courses);
            }

            if (this._configurationService.YearsOptions && this._configurationService.YearsOptions.length > 0) {
                courses = this.filterByYear(courses);
            }

            courses = this.filterByCity(courses);

            this._$numberOfCourses.next(courses.length);
            this.coursesByTitle = courses;
            coursesFiltered = courses.slice(0, this.coursesPerPage);
            filteredMore = courses.slice(this.coursesPerPage, courses.length);
            this._$coursesFilteredMore.next(filteredMore);
            this._$coursesFiltered.next(coursesFiltered);
            if (!this.extendedFilterSelected) {
                this.checkIfCoursesHaveEvents(coursesFiltered);
                this.checkIfCoursesHaveEvents(filteredMore);
            }
        }
        this.getPortalData();
    }

    public getCourses(): Promise<any> {
        return this._coursesService.getAllCourses().then(
            (courses) => {
                this._$categories.next(courses.categories);
                this.courses = courses.courses;
                this._checkIfThereIsCourseWithoutDivision(this.courses);
                this.getSortingOptions(this.currentLanguage, this.courses);
                return this.courses;
            },
            (error) => {
                console.log(error);
                this._$serverError.next(true);
            }
        );
    }

    private _getPortalCourses(portal: string): Promise<any> {
        const _portal = this._portalConfigurationService.getPortalIdWithUnderscore(portal);
        return this._coursesService.getAllPortalCoursesForCourseOverview(_portal, this.lang).then(
            (courses) => {
                this._$categories.next(courses.categories);
                this.courses = courses.courses;
                this._checkIfThereIsCourseWithoutDivision(courses.courses);
                this.getSortingOptions(this.lang, this.courses);
                return this.courses;
            },
            (error) => {
                console.log(error);
                this._$serverError.next(true);
            }
        );
    }

    private _checkIfThereIsCourseWithoutDivision(courses) {
       courses.forEach((course) => {
        if (course.divisions.length === 0) {
            this.coursesWithoutDivision = true;
        }
       });
    }

    private _parseCourses(courses) {
        if (courses.status && courses.status === 404) {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
        } else if (courses.status && courses.status === 500) {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
            this._$showServerError.next(true);
        } else if (courses && courses.length > 0) {
            this._$courses.next(courses);
            const _availableCities = [];
            const _availableYears = [];
            _availableCities.push({ key: this.label, value: this.label });
            this._$availableCities.next(_availableCities);
            _availableYears.push({ key: 0, value: this.label });
            this._$availableYears.next(_availableYears);

            const tempYears = [];
            if (courses && this.sortCourses.length > 0) {
                courses.forEach((course) => {
                    course.events.forEach((event) => {
                        if (event.location && !_availableCities.some((item) => item.value === event.location.city)) {
                            _availableCities.push({ key: event.location.city, value: event.location.city });
                        }
                        const newDate = new Date(event.beginDateTime);
                        const year = newDate.getFullYear();

                        if (year && !tempYears.some((item) => item.value === year)) {
                            tempYears.push({ key: year, value: year });
                        }
                    });
                });
            }

            tempYears.sort((a, b) => (a.key > b.key ? 1 : b.key > a.key ? -1 : 0));

            tempYears.forEach((item) => {
                _availableYears.push(item);
            });

            // sort cities without the first one of "ALL"
            const _first = _availableCities[0];
            const _availableCitiesNew = _availableCities.slice(1).sort((a, b) => a.value.localeCompare(b.value));
            this._$courseFilterCities.next([_first, ..._availableCitiesNew]);
            this._$courseFilterYears.next(_availableYears);
            this.getPortalData();
            this.month = 0;
            if (!this.selectedValueMonth || this.selectedValueMonth === null) {
                this.selectedValueMonth = '0';
            }
            this.year = 0;

            if (!this.selectedValueYear || this.selectedValueYear === null) {
                this.selectedValueYear = '0';
            }
            this.filterCourses();


        } else {
            this._$courses.next([]);
            this._$coursesFiltered.next([]);
        }
    }

    dynamicSort(property, sortReverse) {
        let sortOrder = -1;

        if (sortReverse) {
            sortOrder = 1;
        }

        return (a, b) => {
            const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
            return result * sortOrder;
        };
    }

    public sortCourses(coursesList) {
        this.selectedSortingKey = this.sortValue;
        if (this.selectedSortingKey === 'name') {
            this.sortedCourses = coursesList.sort((a, b) => a.name.localeCompare(b.name));
        } else {
            const optionArray = this._$sortOptions.getValue();
            optionArray.forEach((option) => {
                if (option.key === this.selectedSortingKey) {
                    const labelValue = option.value;
                    const result = this.sortByLabel(coursesList, labelValue);
                    this.sortByLabel(coursesList, labelValue);
                }
            });
        }
    }

    private sortByLabel(coursesList, _label) {
        let withLabel = [];
        let withoutLabel = [];

        coursesList.forEach((element) => {
            if (element.keyWords && element.keyWords[0] && element.keyWords[0].indexOf(_label) > -1) {
                withLabel.push(element);
            } else {
                withoutLabel.push(element);
            }
        });

        withLabel = withLabel.sort((a, b) => a.name.localeCompare(b.name));
        withoutLabel = withoutLabel.sort((a, b) => a.name.localeCompare(b.name));
        const courseList = withLabel.concat(withoutLabel);
        this.sortedCourses = courseList;
    }

    public showFilterByProductType(type: string): boolean {
        return this.courses.filter((x) => x.productType === type).length > 0;
    }

    public filterByType(coursesList) {
        const filteredCourses = [];

        coursesList.forEach((course) => {
            if (this.isPresence) {
                if (course.isProduct === false && (course.productType === 'SEM' || course.productType === 'WRK')) {
                    filteredCourses.push(course);
                }
            }
            if (this.isOnline) {
                if (course.isProduct === true && course.productType === 'WBT') {
                    filteredCourses.push(course);
                }
            }
            if (this.isVirtual) {
                if (course.isProduct === false && course.productType === 'WBN') {
                    filteredCourses.push(course);
                }
            }
        });
        return filteredCourses;
    }
    public filterByYear(courses) {

        const coursesByTitle = [];
        this.year = Number(this.selectedValueYear);

        if (
            this.selectedValueYear !== null &&
            this.selectedValueYear !== '0' &&
            !(this.selectedValueYear === '') &&
            this.selectedValueYear !== 'undefined' &&
            this.selectedValueYear !== this.label
        ) {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    const newDate = new Date(event.beginDateTime);
                    const year = newDate.getFullYear();
                    const month = Number(newDate.getMonth()) + 1;

                    if (year.toString() === this.selectedValueYear && !coursesByTitle.includes(course)) {
                        if (
                            this.selectedValueMonth !== null &&
                            this.selectedValueMonth !== '' &&
                            this.selectedValueMonth !== 'undefined' &&
                            this.selectedValueMonth !== this.label &&
                            this.selectedValueMonth !== '0'
                        ) {
                            if (month.toString() === this.selectedValueMonth && coursesByTitle.indexOf(course) <= -1) {
                                coursesByTitle.push(course);
                            }
                        } else {
                            if (coursesByTitle.indexOf(course) <= -1) {
                                coursesByTitle.push(course);
                            }
                        }
                    }
                });
            });

            courses = coursesByTitle;
        } else {
            return courses;
        }

        return courses;
    }
    public filterByCity(courses) {
        const coursesByTitle = [];

        if (
            this.city !== undefined &&
            this.city !== null &&
            this.city !== '0' &&
            !(this.city === '') &&
            this.city !== this.label &&
            this.city !== 'undefined'
        ) {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    if (event.location.city.toString() === this.city) {
                        const newDate = new Date(event.beginDateTime);
                        const year = newDate.getFullYear();
                        const month = Number(newDate.getMonth()) + 1;
                        if (
                            this.selectedValueMonth !== null &&
                            this.selectedValueMonth !== '0' &&
                            !(this.selectedValueMonth === '') &&
                            this.selectedValueMonth !== 'undefined' &&
                            this.selectedValueMonth !== this.label
                        ) {
                            if (month.toString() === this.selectedValueMonth) {
                                if (
                                    this.selectedValueYear !== null &&
                                    this.selectedValueYear !== '0' &&
                                    !(this.selectedValueYear === '') &&
                                    this.selectedValueYear !== 'undefined' &&
                                    this.selectedValueYear !== this.label
                                ) {
                                    if (year.toString() === this.selectedValueYear && coursesByTitle.indexOf(course) <= -1) {
                                        coursesByTitle.push(course);
                                    }
                                } else {
                                    if (coursesByTitle.indexOf(course) <= -1) {
                                        coursesByTitle.push(course);
                                    }
                                }
                            }
                        } else {
                            if (
                                this.selectedValueYear !== null &&
                                this.selectedValueYear !== '0' &&
                                !(this.selectedValueYear === '') &&
                                this.selectedValueYear !== 'undefined' &&
                                this.selectedValueYear !== this.label
                            ) {
                            } else {
                                if (year.toString() === this.selectedValueYear && coursesByTitle.indexOf(course) <= -1) {
                                    coursesByTitle.push(course);
                                }
                            }
                        }

                        if (coursesByTitle.indexOf(course) <= -1) {
                            coursesByTitle.push(course);
                        }
                    }
                });
            });
            courses = coursesByTitle;
        }

        return courses;
    }
    public filterByMonth(courses) {
        this.setMonthsOptions();

        this.month = Number(this.selectedValueMonth);

        const coursesFiltered = [];

        if (
            this.selectedValueMonth !== null &&
            this.selectedValueMonth !== '0' &&
            !(this.selectedValueMonth === '') &&
            this.selectedValueMonth !== 'undefined'
        ) {
            courses.forEach((course) => {
                course.events.forEach((event) => {
                    const newDate = new Date(event.beginDateTime);
                    const month = Number(newDate.getMonth()) + 1;
                    if (month.toString() === this.selectedValueMonth && !coursesFiltered.includes(course)) {
                        coursesFiltered.push(course);
                    }
                });
            });

            courses = coursesFiltered;
        }
        return courses;
    }

    public filterByTitle(courses) {

        const selectedValue = this._$title.getValue();
        ;
        const coursesByTitle = [];

        if (selectedValue && selectedValue !== null && !(selectedValue === '') && !(selectedValue === 'null')) {
            courses.filter((course) => {
                if (course.name.toLowerCase().indexOf(selectedValue.toLowerCase()) > -1) {
                    coursesByTitle.push(course);
                }
            });

            courses = coursesByTitle;
        }

        this.asc.setResultList(courses);
        return courses;
    }

    public onSelectFilter(selectedValue, parameterKey) {
        this.extendedFilterSelected = true;
        const isPortal = this._configurationService.isPartnerPage();
        const _site = this._configurationService.getCurrentSite();
        if (selectedValue) {
            const value = selectedValue.value || selectedValue;
            switch(parameterKey) {
                case 'month':
                    this.month = value;
                    this.selectedValueMonth = value;
                    this.prepareParameterForURL();
                    this.addParamsToUrl(this.parameter);
                  break;
                case 'year':
                    let valueYearWithoutNumbers = value.split(': ')[1];
                    this.year = valueYearWithoutNumbers;
                    this.selectedValueYear = valueYearWithoutNumbers;
                    this.prepareParameterForURL();
                    this.addParamsToUrl(this.parameter);
                    break;
                case 'city':
                    let valueWithoutNumbers = value.split(': ')[1];
                    this.city = valueWithoutNumbers;
                    this.selectedValueForCity = valueWithoutNumbers;
                    this.prepareParameterForURL();
                    this.addParamsToUrl(this.parameter);
                    break;
                case 'selectedSortingValue':
                     if (isPortal) {
                        const value1 = value.split(': ')[1];
                         this.sortValue = value1;
                         this.selectedSortingKey = this.sortValue;
                         sessionStorage.setItem(`selectedSortingValue${this.portal}`, value1 );
                     } else {
                        const value1 = value.split(': ')[1];
                         this.sortValue = value1;
                         this.selectedSortingKey = this.sortValue;
                         sessionStorage.setItem(`selectedSortingValue${_site}`, value1 );
                     }
                    break;
              }
        }
        this.filterCourses();
    }

    public onSelectFilterByProductType(selectedValue, type: string) {
        this.filterCourses();
        if (type === 'Virtual') {
            if (this.parameter.isVirtual === false) {
                this.isVirtual = true;
            } else {
                this.isVirtual = false;
            }
        } else if (type === 'Presence') {
            if (this.parameter.isPresence === false) {
                this.isPresence = true;
            } else {
                this.isPresence = false;
            }
        } else if (type === 'Online') {
            if (this.parameter.isWBT === false) {
                this.isOnline = true;
            } else {
                this.isOnline = false;
            }
        }
        this.prepareParameterForURL();
        this.addParamsToUrl(this.parameter);
    }

    public hasValue(fieldname) {
        return fieldname ? fieldname.toString() !== '' : false;
    }

    public titleChange(valueTyped) {
        this._$title.next(valueTyped);
        if (valueTyped === '') {
            this.parameter.title = null;
            this._$title.next('');

        }
        this.prepareParameterForURL();
        this.addParamsToUrl(this.parameter);
        this.filterCourses();
    }

    public toggleFilters(value) {
        this._$show.next(value);
        if (!this._$loading.getValue()) {
            this.prepareParameterForURL();
            this.addParamsToUrl(this.parameter);
        }
    }

    public removeParam(parameter) {
        let url = document.location.href;
        const urlparts = url.split('?');

        if (urlparts.length >= 2) {
            const urlBase = urlparts.shift();
            const queryString = urlparts.join('?');

            const prefix = encodeURIComponent(parameter) + '=';
            const pars = queryString.split(/[&;]/g);
            for (let i = pars.length; i-- > 0; ) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            url = urlBase + '?' + pars.join('&');
            window.history.pushState('', document.title, url); // added this line to push the new url directly to url bar .
            window.history.pushState('', document.title, urlBase);
        }
        return url;
    }

    public resetFilters() {
        this.filterResetDone = this.filterResetDone ? false : true;
        this.filters?.reset();
        this._$title.next('');
        this.month = 0;
        this.year = 0;
        this.selectedValueYear = null;
        this.selectedValueMonth = null;
        this.city = this.label;
        this.selectedValueForCity = this.label;
        this._$title.next(null);
        this.isVirtual = true;
        this.isOnline = true;
        this.isPresence = true;
        if (this._$categories.getValue()?.length > 1) {
            this._$selectedValue.next(null);
        }
        this._$selectedValueSubCat.next(null);
        this._$selectedValueSubSubCat.next(null);
        this._$show.next(false);
        this.prepareParameterForURL();
        this.addParamsToUrl(this.parameter);
        this.filterCourses();
    }

    public getPortalData() {
        this.portalLanguage =
            JSON.parse(sessionStorage.getItem('portalLang')) && JSON.parse(sessionStorage.getItem('portalLang')).lang
                ? JSON.parse(sessionStorage.getItem('portalLang')).lang
                : '';

        this.portal = this._configurationService.portalId;
    }

    public checkIfCoursesHaveEvents(courses) {
        const events = [];
        courses.forEach((course) => {
            course.events.forEach((event) => {
                events.push(event);
            });
        });
        if (events.length === 0) {
            // this.parameter.city = null;
            // this.parameter.month = null;
            // this.parameter.year = null;
            // this.parameter.isPresence = true;
            // this.parameter.isWBT = true;
            // this.parameter.isVirtual = true;
        }
    }

    private updatePortalCategories(categories) {
        if (categories.length > 1 || this.coursesWithoutDivision) {
            if (categories[0]?.name !== 'All') {
                const newFirstElement = { id: 0, name: this.label };
                categories = [newFirstElement].concat(categories);
            } else if ( categories.length === 0 && this.coursesWithoutDivision) {
                const newFirstElement = { id: 0, name: this.label };
                categories = [newFirstElement].concat(categories);
            } else {
                if (this.label !== 'All') {
                    categories.shift();
                    const newFirstElement = { id: 0, name: this.label };
                    categories = [newFirstElement].concat(categories);
                }
            }
        }
        if  (categories.length === 1) {
            this._$selectedValue.next(categories[0].id);
        }
        this._$categories.next(categories);
    }

    private updateCategories(categories) {
        if (categories.length > 1 || this.coursesWithoutDivision) {
            const newFirstElement = { id: 0, name: this.label };
            categories = [newFirstElement].concat(categories);
        } else if ( categories.length === 0 && this.coursesWithoutDivision) {
            const newFirstElement = { id: 0, name: this.label };
            categories = [newFirstElement].concat(categories);
        } 
        if  (categories.length === 1) {
            this._$selectedValue.next(categories[0].id);
        }
        this._$categories.next(categories);
        return categories;
    }

    private addParamsToUrl(parameters) {
        this.changeParameterNamesToKeys(parameters);
        this.parameterFromURL = parameters;
        const URL = this._router.createUrlTree([], {relativeTo: this.activatedRoute, queryParams: parameters}).toString();
        this._location.go(URL)
    }

    private getParameterFromURL() {
        const params = this._urlService.getURLParams();
        //this.activatedRoute.queryParams.subscribe((params) => {
            this.parameterFromURL = _.cloneDeep(params);
            this.getNamesOfParameterKeys(params);
            const catIds = [];
            //check if parameter of divisions match
            this._$categories.getValue()?.forEach((cat) => {
                catIds.push(cat.id);
            });
            if (catIds.indexOf(params.division) !== -1 ) {
                this._$selectedValue.next(params.division);
            } else {
                this._$selectedValue.next(null);
                this.parameter.division = null;
                this._$selectedValueSubCat.next(null);
                this.parameter.trainingsSegment = null;
                this._$selectedValueSubSubCat.next(null);
                this.parameter.productArea = null;
            }
            // check if parameter of trainingssegment match
            let subCats = [];

            this._$categories.getValue()?.forEach((cat) => {
                if (cat.id === params.division) {
                    subCats.push(cat.childCategories); 
                }
            });
            subCats = subCats[0];
            const subCatNames = [];
            subCats?.forEach((subCat) => {
                subCatNames.push(subCat.name);
            });
            if (subCatNames.indexOf(this.parameter.trainingsSegment) !== -1 ) {
                this._$selectedValueSubCat.next(this.parameter.trainingsSegment);
            } else {
                this._$selectedValueSubCat.next(null);
                this.parameter.trainingsSegment = null;
                this._$selectedValueSubSubCat.next(null);
                this.parameter.productArea = null;
            }

            //check if parameter of productArea match
            let subSubCats = [];

            subCats?.forEach((subCat) => {
                if (subCat.name === this.parameter.trainingsSegment) {
                    subSubCats.push(subCat.childCategories);
                }
            });
            subSubCats = subSubCats[0];
            const subSubCatNames = [];
            subSubCats?.forEach((subSubCat) => {
                subSubCatNames.push(subSubCat.name);
            });
            if (subSubCatNames.indexOf(this.parameter.productArea) !== -1 ) {
                this._$selectedValueSubSubCat.next(this.parameter.productArea);
            } else {
                this._$selectedValueSubSubCat.next(null);
                this.parameter.productArea = null;
            }
            //check if parameter of month match
            const monthList = [];
            this._$availableMonths.getValue().forEach((month) => {
                monthList.push(month.key);
            });
            if (monthList.indexOf(params.month) !== -1 ) {
                this.selectedValueMonth = params.month;
                this.month = params.month;
            } else {
                this.selectedValueMonth = null;
            }
            //check if parameter of year match
            const yearList = [];
            this._$availableYears.getValue().forEach((year) => {
                yearList.push(year.key.toString())
            });

            if (yearList.indexOf(params.year) !== -1 ) {
                this.selectedValueYear = params.year;
                this.year = Number(params.year);
            } else {
                this.selectedValueYear = '0';
                this.year = 0;
            }

            //check if parameter of city match
            const cityNames = [];
            this._$availableCities.getValue().forEach((city) => {
                cityNames.push(city.key)
            });

            if (cityNames.indexOf(params.city) !== -1 ) {
                this.selectedValueForCity = params.city;
                this.city = params.city;
                this.parameter.city = params.city;
            } else {
                this.selectedValueForCity = null;
                this.city = this.label;
                this.parameter.city = null;
            }

            //check if parameter of types match

            if (params.isWBT === 'false') {
                this.isOnline = false;
                this.parameter.isWBT = false;

            } else {
                this.isOnline = true;
                this.parameter.isWBT = true;
            }
            if (params.isPresence === 'false') {
                this.isPresence = false;
                this.parameter.isPresence = false;

            } else {
                this.isPresence = true;
                this.parameter.isPresence = true;

            }
            if (params.isVirtual === 'false') {
                this.isVirtual = false;
                this.parameter.isVirtual = false
            } else {
                this.isVirtual = true;
                this.parameter.isVirtual = true;
            }            
            this._$title.next(params.title);

            if (params.toggleFilter === 'true'){
                this._$show.next(true);
            } else {
                this._$show.next(false); 
            }
            if (!params.year) {
                this.selectedValueYear = '0';
            }
        //  });
    }

    private prepareParameterForURL() { 
        if (this._$selectedValue.getValue() !== null && this._$selectedValue.getValue() !== '0' &&  this._$selectedValue.getValue() !== undefined && this._$selectedValue.getValue() !== this.label) {
            this.parameter.division = this._$selectedValue.getValue();
        } else {
            this.parameter.division = null;
        }
        if (this._$selectedValueSubCat.getValue() !== null && this._$selectedValueSubCat.getValue() !== '0' &&  this._$selectedValueSubCat.getValue() !== undefined && this._$selectedValueSubCat.getValue() !== this.label) {
            this.parameter.trainingsSegment = this._$selectedValueSubCat.getValue();
        } else {
            this.parameter.trainingsSegment = null;
        }
        if (this._$selectedValueSubSubCat.getValue() !== null && this._$selectedValueSubSubCat.getValue() !== '0' &&  this._$selectedValueSubSubCat.getValue() !== undefined && this._$selectedValueSubSubCat.getValue() !== this.label) {
            this.parameter.productArea = this._$selectedValueSubSubCat.getValue();
        } else {
            this.parameter.productArea = null;
        }
        if (this.selectedValueMonth !== null && this.selectedValueMonth !== '0' &&  this.selectedValueMonth !== undefined) {
            this.parameter.month = this.selectedValueMonth;
        } else {
            this.parameter.month = null;
        }
        if (this.selectedValueYear !== null && this.selectedValueYear !== '0' &&  this.selectedValueYear !== undefined) {
            this.parameter.year = this.selectedValueYear;
        } else {
            this.parameter.year = null;
        }
        if (this.selectedValueForCity !== null && this.selectedValueForCity !== '0' &&  this.selectedValueForCity !== undefined && this.selectedValueForCity !== this.label) {
            this.parameter.city = this.selectedValueForCity;
            this.city = this.selectedValueForCity;
        } else {
            this.parameter.city = null;
            this.city = this.label;

        }
        if (this._$title.getValue()) {
            this.parameter.title = this._$title.getValue();
        } else {
            this.parameter.title = null;
        }
        if (this.isVirtual) {
            this.parameter.isVirtual = null;
        } else {
            this.parameter.isVirtual = false;
        }
        if (this.isOnline) {
            this.parameter.isWBT = null;
        } else {
            this.parameter.isWBT = false;
        }
        if (this.isPresence) {
            this.parameter.isPresence = null;
        } else {
            this.parameter.isPresence = false;
        }
        if (this._$show.getValue()) {
            this.parameter.toggleFilter = this._$show.getValue();
        } else {
            this.parameter.toggleFilter = null;
        }
        this.parameterFromURL = this.parameter;
    }

    private getSortingOptions(lang, courses) {
        this._configurationService.getSortOptions(lang).then((value) => {
            this._$sortOptions.next(value[0]);
            const array = this._$sortOptions.getValue();
            array.forEach((option) => {
                if (option.key === 'Bestseller') {
                    array.splice(array.indexOf(option),1);
                    array.unshift(option);
                }
            }); 
            this._$sortOptions.next(array);
            if (!this.sortValue)  {
                this.sortValue = this._$sortOptions.getValue()[0].key;
            }        
            let sortOptionsTotal
            if (this._$translations.getValue().sortOptions) {
                const sortOptionByName = this._$translations.getValue().sortOptions[0];
                if (this._$sortOptions?.getValue()) {
                    sortOptionsTotal = this._$sortOptions?.getValue().concat(sortOptionByName);
                    this._$sortOptions.next(sortOptionsTotal);
                }
            }
            this.filterSortOptions(courses);
        });

    };

    private filterSortOptions(courses) {
        const courseKeywordsArray = [];
        if (courses) {
            courses.forEach((course) => {
                if (course.keyWords.length > 0) {
                    if (courseKeywordsArray.indexOf(course.keyWords[0]) === -1) {
                        courseKeywordsArray.push(course.keyWords[0]);
                    }
                }
            });
            const filteredSortOptionArray = [];
            this._$sortOptions.getValue().forEach((option) => {
                if (courseKeywordsArray.indexOf(option.value) !== -1 || option.key === 'name' )
                    filteredSortOptionArray.push(option);
            });
            let selectedByUser: string;
            if (this.isPartnerPage) {
                selectedByUser = sessionStorage.getItem(`selectedSortingValue${this.portal}`)
            } else {
                const _site = this._configurationService.getCurrentSite();
                selectedByUser = sessionStorage.getItem(`selectedSortingValue${_site}`)
            }
            if ( !this.sortValue && !this.selectedSortingKey) {
                if (courseKeywordsArray.indexOf('Bestseller') === -1) {
                    if (this.isPartnerPage) {
                        sessionStorage.setItem(`selectedSortingValue${this.portal}`, 'name' );
    
                    } else {
                        const _site = this._configurationService.getCurrentSite();
                        sessionStorage.setItem(`selectedSortingValue${_site}`, 'name' );
                    }
                    this.sortValue = 'name';
                }
            } else if ( !selectedByUser && courseKeywordsArray.indexOf('Bestseller') !== -1) {
                this.sortValue = 'Bestseller';
                if (this.isPartnerPage) {
                    sessionStorage.setItem(`selectedSortingValue${this.portal}`, 'bestseller' );

                } else {
                    const _site = this._configurationService.getCurrentSite();
                    sessionStorage.setItem(`selectedSortingValue${_site}`, 'besteller' );
                }
            }  
            this._$sortOptions.next(filteredSortOptionArray);
            this.selectedSortingKey = this.sortValue;
        }
    }


    private getNamesOfParameterKeys(parameters) {
        // find trainingsSegment key in category Call
        if (!!parameters.trainingsSegment) {
            this._$categories.getValue()?.forEach((cat) => {
                cat.childCategories?.forEach((subCat) => {
                    if (subCat.id === parameters.trainingsSegment) {
                        this.parameter.trainingsSegment = subCat.name;
                        this.parameterFromURL.trainingsSegment = subCat.name;

                        subCat.childCategories?.forEach((subSubCat) => {
                            if (subSubCat.id === parameters.productArea) {
                                this.parameter.productArea = subSubCat.name;
                                this.parameterFromURL.productArea = subSubCat.name;
                            }
                        });
                    }
                });
            });
        }
        return this.parameter;
    }

    private changeParameterNamesToKeys(parameters) {
        // find trainingsSegment key in category Call
        if (!!parameters.trainingsSegment) {
            this._$categories.getValue().forEach((cat) => {
                cat.childCategories?.forEach((subCat) => {
                    if (subCat.name === parameters.trainingsSegment) {
                        parameters.trainingsSegment = subCat.id;
                    }
                });
            });
        }
       
        // find productArea key in category Call
        if (!!parameters.productArea) {
            this._$categories.getValue().forEach((cat) => {
                cat.childCategories?.forEach((subCat) => {
                    subCat.childCategories?.forEach((subSubCat) => {
                        if (subSubCat.name === parameters.productArea) {
                            parameters.productArea = subSubCat.id;
                        }
                    });
                });
            });
        }
        return parameters;
    }
}

